import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatColorResetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_color_reset"}/>
}
